import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { LikedGoodsCardItem } from '../utils/convertLikedGoodsItemToGoodsData';

export const useLogClickAddToCartEntry = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (entry: LikedGoodsCardItem) => {
      logAnalyticsEvent({
        name: 'CLICK_ADD_TO_CART_ENTRY',
        analytics: {
          ...entry.logging.analytics,
          LIST_ID: 'liked_list',
        },
        ably_only_log: entry.logging.ably_only_log,
      });
    },
    [logAnalyticsEvent],
  );
};
